import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import TextField from "../../../ui/TextField";
import RadioGroup from "../../../ui/RadioGroup";
import SearchCondition from "../../../features/SearchCondition";
import { getPeriodMaster } from "../../../../services/apiCourseApplicant";
import Button from "../../../ui/Button";
import Summary from "../../../ui/Summary";
import styles from "../../../layout/admin/Main.module.scss";
import { getCodeMasterList } from "../../../../services/apiCodeMaster";
import { validateMaxlength } from "../../../../utils/validate";
import RangeField from "../../../ui/RangeField";

// 公開・非公開ラジオボタン
const controlDef = 1;

const SearchForm = ({ setSearchCondition }) => {
  // 公開・非公開ラジオボタン
  const [elements, setElements] = useState([]);
  //ラジオボタン選択値
  const [selectedControl, setSelectedControl] = useState(controlDef);
  useEffect(() => {
    (async function () {
      // 公開・非公開
      const data = await getCodeMasterList({ code: "CD007" });
      if (data === undefined || !data) return;
      setElements(
        data.map((d) => {
          return { label: d.d_text, value: d.d_value };
        })
      );
      setValue("control", controlDef);
      // 初期表示時は、申込期間のFROMとTOにperiod_masterの期間をいれて検索した状態で表示
      const periodMaster = await getPeriodMaster();
      if (periodMaster === undefined || !periodMaster) return;
      setValue("period_f_s", periodMaster.date_start);
      setValue("period_t_e", periodMaster.date_end);
    })();
  }, []);

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    setSearchCondition(data);
  };

  const resetCondition = () => {
    setValue("course_name", "");
    setValue("course_content", "");
    setValue("organ", "");
    setValue("period_f_s", "");
    setValue("period_f_e", "");
    setValue("period_t_s", "");
    setValue("period_t_e", "");
    setValue("period", "");
    setValue("keyword", "");
    setValue("control", controlDef);
    setSelectedControl(controlDef);
  };

  return (
    <div>
      <details open>
        <Summary />
        <form onSubmit={handleSubmit(onSubmit)}>
          <SearchCondition title="講座を絞り込む">
            <table>
              <tr>
                <TextField
                  register={register}
                  validation={{
                    ...validateMaxlength(100),
                  }}
                  name="course_name"
                  errors={errors}
                  label="講座名"
                  placeholder="講座名"
                ></TextField>
              </tr>
              <tr>
                <TextField
                  register={register}
                  validation={{
                    ...validateMaxlength(100),
                  }}
                  name="course_content"
                  errors={errors}
                  label="講座内容"
                  placeholder="講座内容"
                ></TextField>
              </tr>
              <tr>
                <TextField
                  register={register}
                  validation={{
                    ...validateMaxlength(100),
                  }}
                  name="organ"
                  errors={errors}
                  label="実施機関"
                  placeholder="実施機関"
                ></TextField>
              </tr>
              <tr>
                <RangeField
                  type="date"
                  register={register}
                  errors={errors}
                  label="申込期間(FROM)"
                  nameTo={"period_f_e"}
                  nameFrom={"period_f_s"}
                ></RangeField>
              </tr>
              <tr>
                <RangeField
                  type="date"
                  register={register}
                  errors={errors}
                  label="申込期間(TO)"
                  nameTo={"period_t_e"}
                  nameFrom={"period_t_s"}
                ></RangeField>
              </tr>
              <tr>
                <TextField
                  register={register}
                  validation={{
                    ...validateMaxlength(100),
                  }}
                  name="period"
                  errors={errors}
                  label="講座開催日・講座時間"
                  placeholder="講座開催日・講座時間"
                ></TextField>
              </tr>
              <tr>
                <TextField
                  register={register}
                  validation={{
                    ...validateMaxlength(100),
                  }}
                  name="keyword"
                  errors={errors}
                  label="検索キーワード"
                  placeholder="検索キーワード"
                ></TextField>
              </tr>
              <tr>
                <RadioGroup
                  errors={errors}
                  register={register}
                  label="公開・非公開"
                  name="control"
                  elements={elements}
                  watch={watch}
                  selectedValue={selectedControl}
                  setSelectedValue={setSelectedControl}
                />
              </tr>
            </table>

            {errors.exampleRequired && <span>This field is required</span>}
          </SearchCondition>
          <div className={styles.buttonbox}>
            <Button type="submit" styleType="search">
              検索
            </Button>
            <Button
              type="button"
              styleType="back"
              onClick={() => resetCondition()}
            >
              条件クリア
            </Button>
          </div>
        </form>
      </details>
    </div>
  );
};

export default SearchForm;
